gsap.registerPlugin(ScrollTrigger); 

//animazioni immagini
document.querySelectorAll(".ourSVG").forEach(svg => {
  const wobble = svg.querySelector(".wobble");
  const setTOrigin = gsap.quickSetter(wobble, "transformOrigin");
  
  gsap.from(wobble, {
    xPercent: -100,
    yPercent: -100,
    ease: "power2.out",
    duration: 2,
    onUpdate: () => setTOrigin('50% 50%'),
    scrollTrigger: {
      trigger: svg,
      start: "top bottom", // when the center of the trigger hits 40% from the top of the viewport
      end: "bottom 50%", // end after scrolling 1000px beyond the start
      scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      
    }
  });
})


//animazioni testi con refrence prese da qui:https://tympanus.net/codrops/2023/01/18/on-scroll-typography-animations/
function initAnimations() {
  //funzione che fa il wrap dei caratteri
  const wrapElements = (elems, wrapType, wrapClass) => {
    elems.forEach(char => {
      const wrapEl = document.createElement(wrapType);
      wrapEl.classList = wrapClass;
      char.parentNode.appendChild(wrapEl);
      wrapEl.appendChild(char);
    });
  }

  //animazione del testo introduttivo nell'hero della home
  document.querySelectorAll(".animation-1").forEach((title) => {
    //richiama la funzione splitting per fare lo split selezionando le classi con il selettore nel target
    const splitChars_1 = Splitting({
      target: title
    });
  
    const chars_1 = splitChars_1[0].chars;
  
    gsap.fromTo(chars_1, { 
      'will-change': 'opacity, transform', 
      opacity: 0, 
      scale: 0.6,
      rotationZ: () => gsap.utils.random(-20,20)
    },
    {
      ease: 'power4',
      opacity: 1,
      scale: 1,
      rotation: 0,
      stagger: 0.05,
    });
  })

  //animazione secondo testo hero home
  document.querySelectorAll(".animation-11").forEach((title) => {
    const splitChars_11 = Splitting({
      target: title
    });

    const chars_11 = splitChars_11[0].chars;
    wrapElements(chars_11, 'span', 'char-wrap');

    gsap.fromTo(chars_11, { 
      'will-change': 'transform', 
      transformOrigin: '0% 50%',
      xPercent: 105,
    }, 
    {
      duration: 1,
      ease: 'expo',
      xPercent: 0,
      stagger: 0.042,
      scrollTrigger: {
        trigger: chars_11,
        start: 'top 90%',
        end: 'top 50%',
        toggleActions: "restart complete complete reset"
      }
    });
  })

  //animazione dei titoli delle varie pagine
  document.querySelectorAll(".animation-11_2").forEach((title) => {
    const splitChars_11_2 = Splitting({
      target: title
    });

    const chars_11_2 = splitChars_11_2[0].chars;
    wrapElements(chars_11_2, 'span', 'char-wrap');

    gsap.fromTo(chars_11_2, { 
      'will-change': 'transform', 
      transformOrigin: '0% 50%',
      xPercent: 105,
    }, 
    {
      duration: 1,
      ease: 'expo',
      xPercent: 0,
      stagger: 0.042,
    });
  })

  //animazioni testi più lunghi
  document.querySelectorAll(".animation-16").forEach((title) => {        
    gsap.fromTo(title, {
      transformOrigin: '0% 50%',
      rotate: 3
    }, {
      ease: 'none',
      rotate: 0,
      scrollTrigger: {
        trigger: title,
        start: 'top bottom',
        end: 'top 50%',
        scrub: true,
      }
    });

    const splitWords = Splitting({
      target: title
    });

    gsap.fromTo(title.querySelectorAll('.word'), {
      'will-change': 'opacity',
      opacity: 0.1
    }, 
    {
      ease: 'none',
      opacity: 1,
      stagger: 0.05,
      scrollTrigger: {
        trigger: title,
        start: 'top bottom',
        end: 'center 70%',
        scrub: true,
      }
    });
  })

  //animazione titoli dei vari blocchi nella home 
  document.querySelectorAll(".animation-22").forEach((title) => {
    const splitChars_22 = Splitting({
      target: title
    });
    const chars = splitChars_22[0].chars;
  
    chars.forEach(char => gsap.set(char.parentNode, { perspective: 1000 })); 
    gsap.fromTo(chars, {
      'will-change': 'opacity, transform', 
      transformOrigin: '50% 0%',
      opacity: 0,
      rotationX: -90,
      z: -200
    }, 
    {
      ease: 'power1',
      opacity: 1,
      stagger: 0.05,
      rotationX: 0,
      z: 0,
      scrollTrigger: {
        trigger: splitChars_22[0].el,
        start: 'center bottom',
        end: 'bottom top+=20%',
        toggleActions: "restart complete complete reset"
      }
    });
  })
        
}